import Avatar from "@/ui/avatar";

import { useToken } from "../../../hooks/use-token";
import { Price } from "@/ui/formats";
import Input from "@/ui/input";
import { formatDecimalStringFloat } from "@/utils/currency";
import GradientBorderRadius from "@/ui/gradient-border-radius";

const LimitInputV2 = ({
  triggerPrice,
  limit,
  onLimitChange,
}: {
  triggerPrice: string;
  limit: string;
  onLimitChange: (limit: string) => void;
}) => {
  const token = useToken();

  return (
    <div className="mt-[0.938rem] flex flex-col gap-y-[0.3125rem]">
      <span className="text-xs font-semibold">Price</span>
      <GradientBorderRadius
        gradient="default-border"
        hover="r-100"
        className="focus-within:before:bg-gradient-100"
      >
        <div className="px-[0.625rem] pl-[0.725rem] h-[1.875rem] flex items-center justify-between">
          <div className="flex items-center gap-x-[0.3125rem]">
            <div className="h-[1.125rem] w-[1.125rem] flex items-center justify-center">
              <Avatar size="input" source={token?.icon ?? ""} />
            </div>
            <Price
              value={
                triggerPrice !== ""
                  ? Number(triggerPrice)
                  : Number(token?.price ?? 0)
              }
              decimals={7}
            />
          </div>
          <div className="w-[5.125rem] text-xs">
            <Input
              value={limit}
              gradient="none"
              hover="none"
              placeholder="0"
              gradientClassName="focus-within:before:bg-none"
              className="!text-opacity-50 h-[1.375rem] text-end"
              onChange={(v) => {
                if (Number(v) < -99.99) {
                  return;
                }

                const formattedValue = formatDecimalStringFloat(v);

                onLimitChange(formattedValue);
              }}
              rightSide={
                <div className="h-[1.375rem] flex items-center justify-center">
                  <Input.Accordion>%</Input.Accordion>
                </div>
              }
            />
          </div>
        </div>
      </GradientBorderRadius>
    </div>
  );
};

export default LimitInputV2;
